<script setup>
const listeners = useListeners()
const props = defineProps({
  value: [String, Number],
  disable: [Boolean, Number],
  selected: Number
})

const selectValue = inject('selectValue')
const setSelectValue = inject('setSelectValue')

const classMap = computed(() => ({
  'nio-option': true,
  'nio-disable': props.disable,
  'nio-selected': props.value === selectValue.value || props.selected
}))
</script>

<template>
  <div
    :class="classMap"
    @click.stop="!disable && setSelectValue(props.value)"
    v-on="!disable && listeners"
  >
    <slot/>
  </div>
</template>

<style lang="scss" scoped>

</style>
